import "../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { h } from "../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
let counter = 0;
const components = {};
const requestSlot = (componentId, slotName, attrs) => {
  var _a;
  return (_a = components[componentId]) == null ? void 0 : _a.requestSlot(slotName, attrs);
};
const uikitRenderer = {
  mountComponent: (_opts) => {
    notInstalled();
    return { id: "", vm: {} };
  },
  update: (_id, _attrs, _requestSlot) => {
    notInstalled();
  },
  unMountComponent: (_id) => {
    notInstalled();
  }
};
const HyperApp = {
  __isTeleport: true,
  process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
    const { p: patch, mt: mount, um: unmount } = internals;
    uikitRenderer.mountComponent = (opts) => {
      const id = "p" + counter++;
      const vnode = h(
        opts.component,
        { ...opts.attrs, "component-id": id, "portalSlots": opts.slots }
      );
      components[id] = { ...opts, vnode };
      mount(vnode, opts.getContainer(), opts.getAnchor(), parentComponent, null, false, slotScopeIds, false);
      updateCssVars(vnode);
      return { id, vm: vnode };
    };
    uikitRenderer.update = (id, attrs, requestSlot2) => {
      const cmp = components[id];
      cmp.vnode.props = {};
      cmp.attrs = attrs;
      if (requestSlot2) {
        cmp.requestSlot = requestSlot2;
      }
      const newNode = h(cmp.component, { ...cmp.attrs, "component-id": id, "portalSlots": cmp.slots });
      patch(cmp.vnode, newNode, cmp.getContainer(), cmp.getAnchor(), null, null, false, slotScopeIds, false);
      cmp.vnode = newNode;
    };
    uikitRenderer.unMountComponent = (id) => {
      const vnode = components[id].vnode;
      unmount(vnode, parentComponent, parentSuspense, true, !!vnode.dynamicChildren);
      delete components[id];
    };
  },
  // eslint-disable-next-line vue/max-len
  remove(vnode, parent, suspence, optimized, { um: unmount }) {
    unmount(vnode.children[0], parent, suspence, true, !!vnode.children[0].dynamicChildren);
  }
};
function updateCssVars(vnode) {
  const ctx = vnode.ctx;
  if (ctx && ctx.ut) {
    let node = vnode.children[0].el;
    while (node !== vnode.targetAnchor) {
      if (node.nodeType === 1) {
        node.setAttribute("data-v-owner", ctx.uid);
      }
      node = node.nextSibling;
    }
    ctx.ut();
  }
}
function notInstalled() {
  console.log("Components package is not installed");
}
export {
  HyperApp,
  requestSlot,
  uikitRenderer
};
//# sourceMappingURL=HyperApp.es.js.map
